import gql from 'graphql-tag'

export const SUBSCRIBE_REQUESTED_TO_ME_ORDERS = gql`
subscription Orders($orgId: uuid!, $filter:String!, $limit: Int!, $offset: Int!){
 Orders(where: {_and: [{to: {_eq: $orgId}},{status: {_eq: "InTransit"}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]},
                {_or: [{orderNum: {_ilike: $filter}},{invoiceNumber: {_ilike: $filter}},
                {FromOrganization:{name: {_ilike: $filter}}},{OrderItems:{Batch:{batch:{_ilike: $filter}}}}]}]},offset: $offset, limit: $limit,order_by: {createdOn: desc}){      
      id
      createdOn
      ToOrganization{id name PartnerType{id prefix}}
      FromOrganization{id name PartnerType{id prefix}}
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      invoiceNote
      OrderItems{ id }
      date
 }
}
`

export const SUBSCRIBE_TRANSIT_ORDERS = gql`
subscription Orders($orgId: uuid!, $filter:String!, $limit: Int!, $offset: Int!){
 Orders(where: {_and: [{from: {_eq: $orgId}},{status: {_eq: "InTransit"}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]},
                {_or: [{orderNum: {_ilike: $filter}},{invoiceNumber: {_ilike: $filter}},
                {ToOrganization:{name: {_ilike: $filter}}},{OrderItems:{Batch:{batch:{_ilike: $filter}}}}]}]},offset: $offset, limit: $limit,order_by: {createdOn: desc}){      
      id
      createdOn
      ToOrganization{id name PartnerType{id prefix}}
      FromOrganization{id name PartnerType{id prefix}}
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      invoiceNote
      OrderItems{ id }
      date
 }
}
`
export const SUBSCRIBE_SOLD_ORDERS = gql`
subscription Orders($orgId: uuid!, $filter: String!, $limit: Int!, $offset: Int!,){
 Orders(where: {_and: [{from: {_eq: $orgId}},{status: {_eq: "Sold"}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]},
                {_or: [{orderNum: {_ilike: $filter}},{invoiceNumber: {_ilike: $filter}},
                {ToOrganization:{name: {_ilike: $filter}}},{OrderItems:{Batch:{batch:{_ilike: $filter}}}}]}]},offset: $offset, limit: $limit,order_by: {createdOn: desc}){      
      id
      createdOn
      ToOrganization{id name PartnerType{id prefix}}
      FromOrganization{id name PartnerType{id prefix}}
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      OrderItems_aggregate{ aggregate{count} }
      date
 }
}
`
export const SUBSCRIBE_PAID_ORDERS_PURCHASE = gql`
subscription Orders($orgId: uuid!, $filter:String!, $limit: Int!, $offset: Int!){
 Orders(where: {_and: [{to: {_eq: $orgId}},{status: {_eq: "Paid"}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]},
                {_or: [{orderNum: {_ilike: $filter}},{invoiceNumber: {_ilike: $filter}},
                {FromOrganization:{name: {_ilike: $filter}}},{OrderItems:{Batch:{batch:{_ilike: $filter}}}}]}]},offset: $offset, limit: $limit,order_by: {createdOn: desc}){      
      id
      createdOn
      ToOrganization{id name PartnerType{id prefix}}
      FromOrganization{id name PartnerType{id prefix}}
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      invoiceNote
      OrderItems{ id }
      date
 }
}
`
export const SUBSCRIBE_PAID_ORDERS_SALES = gql`
subscription Orders($orgId: uuid!, $filter: String!, $limit: Int!, $offset: Int!){
 Orders(where: {_and: [{from: {_eq: $orgId}},{status: {_eq: "Paid"}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]},               
                {_or: [{orderNum: {_ilike: $filter}},{invoiceNumber: {_ilike: $filter}},
                {ToOrganization:{name: {_ilike: $filter}}},{OrderItems:{Batch:{batch:{_ilike: $filter}}}}]}]},offset: $offset, limit: $limit,order_by: {createdOn: desc}){      
      id
      createdOn
      ToOrganization{id name PartnerType{id prefix}}
      FromOrganization{id name PartnerType{id prefix}}
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      OrderItems_aggregate{ aggregate{count} }
      date
 }
}
`
export const SUBSCRIBE_PAID_ORDERS_FOR_OTHERS = gql`
subscription Orders($orgId: uuid!){
 Orders(where: {_and: [{to: {_eq: $orgId}},{status: {_eq: "Paid"}}]}, order_by: {createdOn: desc}){            
      id
      from
      PlacedBy{id name}
      orderNum
      OrderItems{
        productId
        orderItemId: id
        orderItemStatus: status
        Product{name id productLineCode ProductLine{name} OEM{name}}
        Batch{batch id productId status sku}
      }
 }
}
`
export const SUBSCRIBE_DUE_ORDERS = gql`
subscription Orders($orgId: uuid!, $filter:String!, $limit: Int!, $offset: Int!){
 Orders(where: {_and: [{to: {_eq: $orgId}},{status: {_eq: "Sold"}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]},
                {_or: [{orderNum: {_ilike: $filter}},{invoiceNumber: {_ilike: $filter}},
                {FromOrganization:{name: {_ilike: $filter}}},{OrderItems:{Batch:{batch:{_ilike: $filter}}}}]}]},offset: $offset, limit: $limit,order_by: {createdOn: desc}){      
      id
      createdOn
      ToOrganization{id name PartnerType{id prefix}}
      FromOrganization{id name PartnerType{id prefix}}
      PlacedBy{id name}
      orderNum
      invoiceNumber
      invoiceDate
      invoiceNote
      OrderItems{ id }
      date
 }
}
`

export const SUBSCRIBE_ORDERS_TOTALCOUNT_SALESDETAIL = gql` 
subscription($orgId: uuid!, $filter: String!, $status: String!){
 ordersCount:Orders_aggregate(where: {_and: [{from: {_eq: $orgId}},{status: {_eq: $status}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]},
                {_or: [{orderNum: {_ilike: $filter}},{invoiceNumber: {_ilike: $filter}},
                {ToOrganization:{name: {_ilike: $filter}}},{OrderItems:{Batch:{batch:{_ilike: $filter}}}}]}]}){      
      aggregate{count}
 }
}
`
export const SUBSCRIBE_ORDERS_TOTALCOUNT_PURCHASEDETAIL = gql` 
subscription($orgId: uuid!, $filter: String!, $status: String!){
 ordersCount:Orders_aggregate(where: {_and: [{to: {_eq: $orgId}},{status: {_eq: $status}},{_or:[{orderType: {_eq: 1}},{orderType: {_is_null: true}}]},
                {_or: [{orderNum: {_ilike: $filter}},{invoiceNumber: {_ilike: $filter}},
                {FromOrganization:{name: {_ilike: $filter}}},{OrderItems:{Batch:{batch:{_ilike: $filter}}}}]}]}){      
      aggregate{count}
 }
}
`

export const SUBSCRIBE_RETAIL_ORDERS_TOTALCOUNT = gql` 
subscription($orgId: uuid!, $filter: String!, $status: String!){
 esetOrdersCount:Orders_aggregate(where: {_and: [{from: {_eq: $orgId}},{status: {_eq: $status}},{orderType: {_eq: 2}},
                {_or: [{orderNum: {_ilike: $filter}},{invoiceNumber: {_ilike: $filter}},
                {ToCustomer:{name: {_ilike: $filter}}},{ToCustomer:{mobile: {_ilike: $filter}}},{OrderItems:{ProductInventory:{serial:{_ilike: $filter}}}}]}]}){      
      aggregate{count}
 }
}`
export const SUBSCRIBE_RETAIL_SALES_ORDERS = gql`
subscription Orders($orgId: uuid!, $filter: String!, $limit: Int!, $offset: Int!, $sortObj: [Orders_order_by!]){
 esetOrders:Orders(where: {_and: [{from: {_eq: $orgId}},{status: {_eq: "Sold"}},{orderType: {_eq: 2}},
                {_or: [{orderNum: {_ilike: $filter}},{invoiceNumber: {_ilike: $filter}},
                {ToCustomer:{name: {_ilike: $filter}}},{ToCustomer:{mobile: {_ilike: $filter}}},{OrderItems:{ProductInventory:{serial:{_ilike: $filter}}}}]}]},offset: $offset, limit: $limit,order_by: $sortObj){
      id
      ToCustomer{id name mobile email companyName}
      FromOrganization{id name PartnerType{id prefix}}
      PlacedBy{id name}
      orderNum
      createdOn
      invoiceNumber
      invoiceNote
      invoiceDate
      OrderItems_aggregate{ aggregate{count} }
      date
 }
}`

export const SUBSCRIBE_RETAIL_FORTINET_ORDERS_TOTAL_COUNT = gql`
subscription($orgId: uuid!, $filter: String!, $status: String!){
 fortinetOrdersCount:Orders_aggregate(where: {_and: [{from: {_eq: $orgId}},{status: {_eq: $status}},{orderType: {_eq: 4}},
                {_or: [{orderNum: {_ilike: $filter}},{invoiceNumber: {_ilike: $filter}},
                {ToCustomer:{name: {_ilike: $filter}}},{ToCustomer:{mobile: {_ilike: $filter}}},{OrderItems:{ProductInventory:{serial:{_ilike: $filter}}}}]}]}){      
      aggregate{count}
 }
}`
export const SUBSCRIBE_RETAIL_SALES_FORTINET_ORDERS = gql`
subscription Orders($orgId: uuid!, $filter: String!, $limit: Int!, $offset: Int!, $sortObj: Orders_order_by!, $sortSupportObj: AMCPlanHistory_order_by){
 FortinetOrders: Orders(where: {_and: [{from: {_eq: $orgId}},{status: {_eq: "Sold"}},{orderType: {_eq: 4}},
                {_or: [{orderNum: {_ilike: $filter}},{invoiceNumber: {_ilike: $filter}},
                {ToCustomer:{name: {_ilike: $filter}}},{ToCustomer:{mobile: {_ilike: $filter}}},{OrderItems:{ProductInventory:{serial:{_ilike: $filter}}}}]}]},offset: $offset, limit: $limit, order_by: [$sortObj,{FortinetOrderItem: {LastSupportPlan: $sortSupportObj}}]){
      id
      ToCustomer{id name mobile email phone city companyName}
      FromOrganization{id name partnerCode Users{id name mobile email}}
      PlacedBy{id name}
      orderNum
      createdOn
      date
      invoiceNumber
      invoiceNote
      invoiceDate
      OrderItems{
        id meta
        SupportPlans(order_by: {created_at: desc}){
          id
          serialNo
          startDate
          endDate
          created_at
          Partner{id name partnerCode Users{id name mobile email}}
          Product{id name sku}
          SupportPlan{id name}
        }
      }
 }
}`
